import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { jwtDecode } from "jwt-decode";

/* ============================= */
/*           TYPES               */
/* ============================= */

interface UserRoles {
	hasConsignor: boolean;
	hasEventVue: boolean;
	hasDataVue: boolean;
	hasEditLockDownCosts: boolean;
}

interface JwtPayload {
	Consignor?: string;
	EventVue?: string;
	DataVue?: string;
	EditLockDownCost?: string | boolean;
}

interface LoginRequest {
	UserName: string;
	Password: string;
}

interface LoginResponse {
	token: string;
	roles?: UserRoles | null;
}

/* ============================= */
/*        INITIAL STATE          */
/* ============================= */

const initialState: LoginResponse = {
	token: "",
	roles: null,
};

/* ============================= */
/*        SLICE + THUNK          */
/* ============================= */

export const { thunk: login, slice: loginSlice } = getThunkAndSlice<LoginRequest, LoginResponse>({
	initialState,
	path: "/Account/Jwt_Login",
	method: "post",

	/* ============================= */
	/*      BEFORE REQUEST (INIT)    */
	/* ============================= */

	onBeforeRequest: () => {
		const token = localStorage.getItem("token");

		if (token) {
			ApiProvider.default.setToken(token);

			const decoded = jwtDecode<JwtPayload>(token);

			return {
				token,
				roles: {
					hasConsignor: decoded.Consignor === "True",
					hasEventVue: decoded.EventVue === "True",
					hasDataVue: decoded.DataVue === "True",
					hasEditLockDownCosts: decoded.EditLockDownCost === "True" || decoded.EditLockDownCost === true,
				},
			};
		}
	},

	/* ============================= */
	/*          ON LOGIN             */
	/* ============================= */

	onData: (data) => {
		ApiProvider.default.setToken(data.token);

		const decoded = jwtDecode<JwtPayload>(data.token);

		data.roles = {
			hasConsignor: decoded.Consignor === "True",
			hasEventVue: decoded.EventVue === "True",
			hasDataVue: decoded.DataVue === "True",
			hasEditLockDownCosts: decoded.EditLockDownCost === "True" || decoded.EditLockDownCost === true,
		};

		localStorage.setItem("token", data.token);
	},
});
